
import React, { useState, useRef } from "react";
import { FaMapMarked } from "react-icons/fa";
import useEscapeKey from "../utils/useEscapeKey";

const MapPin = ({ top, right, name, description, maps }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  const togglePopover = () => setIsOpen((prev) => !prev);
  const closePopover = () => setIsOpen(false);

  useEscapeKey(closePopover, isOpen);

  const handleClickOutside = (event) => {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className="absolute -translate-y-1/2 translate-x-1/2"
      style={{ top: top, right: right }}
    >
      <button
        onClick={togglePopover}
        aria-label={name}
        className="relative flex h-5 w-5 items-center justify-center"
      >
        <span className="absolute h-full w-full animate-ping rounded-full bg-sky-500/40 motion-reduce:animate-none" />
        <span className="relative h-2.5 w-2.5 rounded-full bg-sky-500 ring-2 ring-white dark:ring-slate-900" />
      </button>
      {/* Popover Content */}
      {isOpen && (
        <div
          ref={popoverRef}
          className="card absolute bottom-full left-1/2 z-50 mb-3 w-52 -translate-x-1/2 !bg-white shadow-xl dark:!bg-slate-900"
        >
          <div className="flex flex-col p-4 gap-3">
            <div className="flex flex-row justify-between items-center">
              <h4 className="font-semibold">{name}</h4>
              <a href={maps} target="_blank" rel="noopener noreferrer">
                <FaMapMarked className="h-5 w-5 text-sky-500 hover:text-sky-400" />
              </a>
            </div>
            <div className="flex flex-col gap-1 text-sm text-slate-600 dark:text-slate-400">
              {description.map((line) => (
                <p key={line}>
                  {line}
                </p>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapPin;